<app-dialog-title>{{ 'reject' | transloco }} {{taxReturnAlias}}</app-dialog-title>
<mat-dialog-content>
    <change-reason
        [taxReturn]="taxReturn"
        actionType="reject"
        (cancel)="onClose()"
        (completed)="processTaxReturn();onClose(true)"
    ></change-reason>
</mat-dialog-content>
